<template>
  <v-chip small :color="status.color" :text-color="status.text_color">
    {{ status.text }}
  </v-chip>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    statuses: {
      agent: {
        text: "Agente",
        color: "",
        text_color: "black",
      },
    },
  }),

  computed: {
    status() {
      return this.statuses[this.value] || { text: this.value, color: "grey" };
    },
  },
};
</script>
